"use client";

import { useRef, useEffect, ReactNode } from "react";
import { useHeaderHeight } from "@/app/providers/navigationProvider";
import useMediaQuery from "@/utils/useMediaQuery";

export default function ShopLayoutClient({
  children,
  footer,
  isDuda,
}: Readonly<{
  children: ReactNode;
  footer: ReactNode;
  isDuda?: boolean;
}>) {
  const mainRef = useRef<HTMLElement>(null);
  const {
    headerHeight,
    previousHeight,
    hasStorefrontHeader,
    recalculateHeight,
  } = useHeaderHeight();
  const hasLayoutChanged = useMediaQuery("(max-width: 640px)");

  useEffect(() => {
    if (mainRef.current) {
      let effectiveHeaderHeight = 0;
      if (hasStorefrontHeader) {
        effectiveHeaderHeight = isDuda
          ? headerHeight
          : Math.max(headerHeight, previousHeight);
      }

      mainRef.current.style.paddingTop = `${effectiveHeaderHeight}px`;
      mainRef.current.style.scrollPaddingTop = `${effectiveHeaderHeight}px`;
    }
  }, [headerHeight, previousHeight, hasStorefrontHeader, isDuda]);

  useEffect(() => {
    if (isDuda) return;
    if (hasLayoutChanged && mainRef.current) {
      recalculateHeight();
    }
  }, [hasLayoutChanged, headerHeight, isDuda]);

  return (
    <main
      ref={mainRef}
      className="flex flex-col items-center flex-1 overflow-scroll w-full"
    >
      <div className="flex-1 flex flex-col w-full mx-0">{children}</div>
      <footer className="w-full">{footer}</footer>
    </main>
  );
}
